import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, unit } from '@zego/theme';
import useTracking from '@zego/tracking/useTracking';

import Button from '@zego/components/atoms/Button';

const StyledGetAQuoteButton = styled(Button)({
  height: unit(8),
  [BREAKPOINTS.smallOnly]: { width: '100%' },
});

interface GetAQuoteProps
  extends React.ComponentProps<typeof StyledGetAQuoteButton> {
  onClickAction: () => void;
  trackEventString: string;
  salesforceCampaignId?: string;
}

export default function GetAQuoteButton({
  onClickAction,
  trackEventString,
  ...rest
}: GetAQuoteProps): JSX.Element {
  const { trackEvent } = useTracking();

  return (
    <StyledGetAQuoteButton
      testId="get-a-quote-button"
      onClick={(event): void => {
        event.preventDefault();
        onClickAction();
        trackEvent(trackEventString);
      }}
      {...rest}
    >
      Get a quote
    </StyledGetAQuoteButton>
  );
}
